<div
  class="m-2 rounded-full lg:w-8 md:w-6 sm:w-5 w-5 lg:h-8 md:h-6 sm:h-5 h-5 flex items-center justify-center overflow-hidden cursor-pointer"
>
    <!-- (ngModelChange)="onThemeChange()" -->
  <p-togglebutton
    [(ngModel)]="theme"
    onLabel="claro"
    offLabel="oscuro"
    class="w-10"
  >
    <ng-template #icon let-checked>
      @if (checked) {
        <img
          id="iconSun"
          class="rounded-full w-8 h-8 object-cover"
          src="/svg/sun.svg"
          alt="Tema claro"
          tooltip="Tema Claro"
        />
      } @else {
        <img
          id="iconMoon"
          class="rounded-full w-8 h-8 object-cover"
          src="/svg/moon.svg"
          alt="Tema oscuro"
          tooltip="Tema oscuro"
        />
      }
    </ng-template>
  </p-togglebutton>
</div>
